import swal from 'sweetalert2'

const default_configuration = {
  backdrop: true,
  confirmButtonColor: '#006E78',
  position: 'center',
}

export const swalInfo = (title, html, text) => {
  const obj = { ...default_configuration }

  obj.title = title
  if (html) obj.html = html
  obj.text = text

  return swal.fire(obj)
}

export const swalError = (title, text) => {
  const obj = { ...default_configuration }

  obj.title = title
  obj.text = text
  obj.type = 'error'

  return swal.fire(obj)
}

export const swalWarning = (title, confirmButtonText, cancelButtonText, showCancelButton, html, text) => {
  const obj = { ...default_configuration }

  obj.title = title
  obj.html = html
  obj.text = text
  obj.confirmButtonText = confirmButtonText
  obj.showCancelButton = showCancelButton
  obj.cancelButtonText = cancelButtonText
  obj.type = 'warning'

  return swal.fire(obj)
}

export const swalSuccess = (title, text, confirmButtonText, html, timer) => {
  const obj = { ...default_configuration }

  obj.title = title
  if (!obj.text) obj.html = html
  if (!html) obj.text = text
  obj.confirmButtonText = confirmButtonText
  if (obj.confirmButtonText === null) obj.showConfirmButton = false
  obj.type = 'success'
  if (timer) obj.timer = timer

  return swal.fire(obj)
}

export const swalNotify = (text, timer = 1500) => {
  const obj = { ...default_configuration }

  obj.showCancelButton = false
  obj.showConfirmButton = false
  obj.timer = timer
  obj.type = 'success'
  obj.title = text

  return swal.fire(obj)
}

export const swalChoose = (title, text, buttonTexts) => {
  const obj = { ...default_configuration }

  obj.title = title
  obj.html = text
  obj.type = 'info'
  obj.showCancelButton = true
  obj.confirmButtonText = buttonTexts[0]
  obj.cancelButtonText = buttonTexts[1]

  obj.cancelButtonColor = '#006E78'

  return swal.fire(obj)
}
